// @flow
import { createContext } from 'react';

export const SPMLDMutationsContext = createContext({});
